/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "proto/address/models.proto" (package "rd.proto.address", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * Address represents a street address.
 *
 * @generated from protobuf message rd.proto.address.Address
 */
export interface Address {
    /**
     * @generated from protobuf field: string line_1 = 1
     */
    line1: string;
    /**
     * @generated from protobuf field: string line_2 = 2
     */
    line2: string;
    /**
     * @generated from protobuf field: string city = 3
     */
    city: string;
    /**
     * @generated from protobuf field: string state = 4
     */
    state: string;
    /**
     * @generated from protobuf field: string postal_code = 5
     */
    postalCode: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address.Country country = 6
     */
    country: Address_Country; // Assume US if UNDEFINED
}
/**
 * @generated from protobuf enum rd.proto.address.Address.Country
 */
export enum Address_Country {
    /**
     * @generated from protobuf enum value: COUNTRY_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: COUNTRY_US = 1;
     */
    US = 1,
    /**
     * @generated from protobuf enum value: COUNTRY_CA = 2;
     */
    CA = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class Address$Type extends MessageType<Address> {
    constructor() {
        super("rd.proto.address.Address", [
            { no: 1, name: "line_1", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "line_2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "postal_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "country", kind: "enum", T: () => ["rd.proto.address.Address.Country", Address_Country, "COUNTRY_"] }
        ]);
    }
    create(value?: PartialMessage<Address>): Address {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.line1 = "";
        message.line2 = "";
        message.city = "";
        message.state = "";
        message.postalCode = "";
        message.country = 0;
        if (value !== undefined)
            reflectionMergePartial<Address>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Address): Address {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string line_1 */ 1:
                    message.line1 = reader.string();
                    break;
                case /* string line_2 */ 2:
                    message.line2 = reader.string();
                    break;
                case /* string city */ 3:
                    message.city = reader.string();
                    break;
                case /* string state */ 4:
                    message.state = reader.string();
                    break;
                case /* string postal_code */ 5:
                    message.postalCode = reader.string();
                    break;
                case /* rd.proto.address.Address.Country country */ 6:
                    message.country = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Address, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string line_1 = 1; */
        if (message.line1 !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.line1);
        /* string line_2 = 2; */
        if (message.line2 !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.line2);
        /* string city = 3; */
        if (message.city !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.city);
        /* string state = 4; */
        if (message.state !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.state);
        /* string postal_code = 5; */
        if (message.postalCode !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.postalCode);
        /* rd.proto.address.Address.Country country = 6; */
        if (message.country !== 0)
            writer.tag(6, WireType.Varint).int32(message.country);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.proto.address.Address
 */
export const Address = new Address$Type();
